<template>
    <v-row>
        <v-col cols="12" md="12" style="padding-left: 35px;">
            <v-row>
                <v-col cols="12" md="12">
                    <h2>{{ trans('user_detail.targets') }}</h2>
                    <div class="float-right" style="margin-right: 20px;">
                        <v-btn color="warning" @click="show_filters = !show_filters" small><v-icon>tune</v-icon></v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="show_filters">
                <v-col cols="6" md="6">
                    <v-text-field
                        v-model="search"
                        prepend-icon="search"
                        clearable
                        :label="trans('common.search')"

                        >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="targets">


                <v-col cols="12" md="12">


                    <v-data-table
                        :headers="headers"
                        :items="targets"

                        :items-per-page="10"
                        class="elevation-1"
                        :footer-props="footer"
                        :search="search"
                        :custom-filter="customSearch"
                        >
                        <template v-slot:item.id="{item}">
                            <v-btn depressed small color="warning" :href="user_target_edit_route(item.id)"><v-icon>edit</v-icon></v-btn>
                        </template>

                        <template v-slot:item.target_deadline="{item}">
                            {{ item.target_deadline | date }}
                        </template>
                        <template v-slot:item.user_target_completed="{item}">
                            {{ item.user_target_completed | date }}
                        </template>

                    <template v-slot:item.totalEndedActivities="{item}">
                        <v-progress-linear style="border-radius: 8px;"
                                            :value="perc(item.totalActivities, item.totalEndedActivities)"
                                            :color="percCustomColor(item.totalActivities, item.totalEndedActivities)"
                                            height="30">
                                            <small>({{ item.totalEndedActivities }}/{{ item.totalActivities }})
                                            {{ trans('users_targets_progressions.fields.activities') }}</small>
                        </v-progress-linear>
                    </template>

                    <template v-slot:item.target_allocated_time="{item}">
                        {{ roundedHours(item.target_allocated_time) }}
                    </template>

                    <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} / {{ items.itemsLength }}
                </template>


            </v-data-table>


                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" md="12">{{ trans('common.no_results') }}</v-col>
            </v-row>

        </v-col>
    </v-row>
</template>
<script>


export default {

    name: "user-targets",

    props: {
        user_targets: { type: Array, default: [] },
        user_target_action: { default: ''}


    },
    data() {

        let targets = this.user_targets;
        return {
            headers: [

            { text: trans('users_targets_progressions.fields.target_name'), value: 'target_name' },
            { text: trans('users_targets_progressions.fields.target_deadline'), value: 'target_deadline' },
            { text: trans('users_targets_progressions.fields.user_target_worked_time_sec') , value: 'totalEndedActivities' },
            { text: trans('users_targets_progressions.fields.target_allocated_time'), value: 'target_allocated_time' },
            { text: trans('users_targets_progressions.fields.user_target_completed'), value: 'user_target_completed' },
            { text: '', sortable: false, value: 'id' },

            ],
            footer: {
                itemsPerPageText: trans('common.table.footer.items_per_page'),
                itemsPerPageAllText: trans('common.table.footer.items_per_page_all'),
            },
            search: '',
            targets,
            show_filters: false
        }
    },

    mounted() {
    },
    methods: {

        customSearch (value, search, item) {

           return Object.values(item).some(
             v=>v
             && (v.toString().toLowerCase().includes(search)
             || v.toString().toUpperCase().includes(search))
             )
       },


        user_target_edit_route(id){
            let action = this.user_target_action;
            return action.replace(':id',id)
        },


        roundedHours(second_hours) {
            let fl_hours = second_hours / 3600;
            return Math.round(fl_hours * 100) / 100
        },

        perc(max, current) {
            let kx = 100.0 / parseFloat(max);
            let y = parseFloat(current) * kx;
            return Math.round(y * 100.0) / 100.0;

        },

        percCustomColor(max, min) {

            let perc = this.perc(max, min);

            // default green
            let color = '#4CAF50'; // 100%
            let background_color = '#A5D6A7';

            if (perc < 25.0) {
                // red
                color = '#F44336';
                background_color = '#EF9A9A';

            } else if (perc <= 50.0) {
                // orange
                color = '#FFB74D'; // orange lighten-2
                background_color = '#FFE0B2'; // orange lighten-4


            } else if (perc < 75.0) {
                // orange
                color = '#FF9800';
                background_color = '#FFE0B2';


            } else if (perc > 105) {

                background_color = '#EF9A9A';

                if (perc < 110) {
                    // lime darken-4
                    color = '#827717';

                } else if (perc < 125) {
                    // deep-orange darken-4
                    color = '#BF360C';

                } else if (perc < 150) {
                    // red accent-4
                    color = '#D50000';

                } else if (perc < 175) {
                    // pink accent-4
                    color = '#C51162';

                } else if (perc > 175) {
                    // purple accent-4
                    color = '#AA00FF';
                }

            }

            return color;
        },


    },

    computed: {


    },



}

</script>
